module.exports = __webpack_public_path__ + "media/images/konintodoke/top_recommend/sakura-left-icon-29d8e2de5bb1a7396872f55f5b01758f.svg";